import { render } from "./HomeOrders.vue?vue&type=template&id=77ae38aa&scoped=true"
import script from "./HomeOrders.vue?vue&type=script&lang=js"
export * from "./HomeOrders.vue?vue&type=script&lang=js"

import "./HomeOrders.vue?vue&type=style&index=0&id=77ae38aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ae38aa"]])

export default __exports__